import React from 'react';

import { SHDFancyRuleProps } from './SHDFancyRule.d';

import {
  fancyRuleContainer,
  fancyRuleBorder,
  fancyRuleLabel,
} from './SHDFancyRule.style';

const SHDFancyRule: React.FC<SHDFancyRuleProps> = ({
  className = 'fancy-rule',
  label,
}) => {
  return (
    <div className={className} style={fancyRuleContainer}>
      <span
        className={`${className}__line`}
        style={fancyRuleBorder as React.CSSProperties}
      ></span>
      <span
        className={`${className}__label`}
        style={fancyRuleLabel as React.CSSProperties}
      >
        {label}
      </span>
      <span
        className={`${className}__line`}
        style={fancyRuleBorder as React.CSSProperties}
      ></span>
    </div>
  );
};

export default SHDFancyRule;
